// src/chains/family.ts
var ChainFamily = {
  EVM: "evm",
  UTXO: "utxo",
  SOLANA: "solana",
  COSMOS: "cosmos",
  OTHER: "other"
};
function isChainFamily(value) {
  return typeof value === "string" && Object.values(ChainFamily).includes(value);
}

// src/chains/seed-data.ts
var CHAIN_MAPPING = {
  "0x1": "eth",
  "0x3d": "etc",
  "0x89": "polygon",
  "0x38": "bsc",
  "0xa86a": "avalanche",
  "0xfa": "fantom",
  "0x19": "cronos",
  "0x2a15c308d": "palm",
  "0xa4b1": "arbitrum",
  "0x64": "gnosis",
  "0x15b38": "chiliz",
  "0x2105": "base",
  "0xa": "optimism",
  "0x2019": "klaytn",
  "0xa4ec": "celo",
  "0x8ae": "kava",
  "0x440": "metis",
  "0x63564c40": "harmony",
  "0x2b6653dc": "zkSync",
  "0x171": "aurora",
  "0x1388": "matic",
  "0x505": "moonriver",
  "0x504": "moonbeam",
  "0x144": "zkSync_era",
  "0x118": "zkSync_testnet",
  "0x405": "linea",
  "0x44d": "scroll",
  "0xa0c71fd": "mantle_testnet",
  "0x5": "goerli",
  "0xaa36a7": "sepolia",
  "0x13881": "mumbai",
  "0x61": "bsc_testnet",
  "0x27d8": "gnosis_chiado",
  "0x15b32": "chiliz_spicy",
  "0x14a33": "base_goerli",
  "0x1a4": "optimism_goerli",
  "0x82750": "klaytn_baobab",
  "0xaef3": "celo_alfajores",
  "0x8ad": "kava_testnet",
  "0x24c": "metis_goerli",
  "0x6357d2e0": "harmony_testnet",
  "0x66eee": "aurora_testnet",
  "0x507": "moonbase",
  "0x145": "zkSync_era_testnet",
  "0x7a": "fuse_testnet",
  "0xe704": "linea_testnet",
  "0x8274f": "scroll_testnet",
  "0x2611": "plasma"
};
var MAINNET_CHAINS = [
  "eth",
  "etc",
  "polygon",
  "bsc",
  "avalanche",
  "fantom",
  "arbitrum",
  "optimism",
  "klaytn",
  "celo",
  "kava",
  "metis",
  "harmony",
  "palm",
  "cronos",
  "gnosis",
  "chiliz",
  "base",
  "zkSync",
  "aurora",
  "matic",
  "moonriver",
  "moonbeam",
  "zkSync_era",
  "fuse",
  "linea",
  "scroll",
  "mantle"
];
var TESTNET_CHAINS = [
  "goerli",
  "sepolia",
  "mumbai",
  "bsc_testnet",
  "gnosis_chiado",
  "chiliz_spicy",
  "base_goerli",
  "optimism_goerli",
  "klaytn_baobab",
  "celo_alfajores",
  "kava_testnet",
  "metis_goerli",
  "harmony_testnet",
  "zkSync_testnet",
  "aurora_testnet",
  "moonbase",
  "zkSync_era_testnet",
  "fuse_testnet",
  "linea_testnet",
  "scroll_testnet",
  "mantle_testnet"
];
var LAYER1_CHAINS = [
  "eth",
  "etc",
  "bsc",
  "avalanche",
  "fantom",
  "klaytn",
  "celo",
  "kava",
  "harmony",
  "matic",
  "moonriver",
  "moonbeam",
  "fuse"
];
var LAYER2_CHAINS = [
  "polygon",
  "arbitrum",
  "optimism",
  "metis",
  "base",
  "zkSync",
  "zkSync_era",
  "linea",
  "scroll",
  "mantle"
];
var SIDECHAINS = ["palm", "gnosis", "cronos", "aurora"];
var CHAIN_CONFIG = {
  "0x1": { token: "ETH", gasUnit: "Gwei", name: "Ethereum" },
  "0x3d": { token: "ETC", gasUnit: "Gwei", name: "Ethereum Classic" },
  "0x89": { token: "MATIC", gasUnit: "Gwei", name: "Polygon" },
  "0x38": { token: "BNB", gasUnit: "Gwei", name: "BNB Chain" },
  "0xa4b1": { token: "ARB", gasUnit: "Gwei", name: "Arbitrum" },
  "0x2105": { token: "ETH", gasUnit: "Gwei", name: "Base" },
  "0xa": { token: "ETH", gasUnit: "Gwei", name: "Optimism" },
  "0xe708": { token: "ETH", gasUnit: "Gwei", name: "Linea" },
  "0xa86a": { token: "AVAX", gasUnit: "nAVAX", name: "Avalanche" },
  "0xfa": { token: "FTM", gasUnit: "Gwei", name: "Fantom" },
  "0x19": { token: "CRO", gasUnit: "Gwei", name: "Cronos" },
  "0x64": { token: "xDAI", gasUnit: "Gwei", name: "Gnosis" },
  "0x15b38": { token: "CHZ", gasUnit: "Gwei", name: "Chiliz" },
  "0x171": { token: "PLS", gasUnit: "Gwei", name: "PulseChain" },
  "0x504": { token: "GLMR", gasUnit: "Gwei", name: "Moonbeam" },
  "0x505": { token: "MOVR", gasUnit: "Gwei", name: "Moonriver" },
  "0x13e31": { token: "ETH", gasUnit: "Gwei", name: "Blast" },
  "0x144": { token: "ETH", gasUnit: "Gwei", name: "zkSync Era" },
  "0x1388": { token: "MNT", gasUnit: "Gwei", name: "Mantle" },
  "0xcc": { token: "BNB", gasUnit: "Gwei", name: "opBNB" },
  "0x44d": { token: "MATIC", gasUnit: "Gwei", name: "Polygon zkEVM" },
  "0x1b58": { token: "ZETA", gasUnit: "Gwei", name: "ZetaChain" },
  "0x2eb": { token: "FLOW", gasUnit: "FLOW units", name: "Flow" },
  "0x7e4": { token: "RON", gasUnit: "Gwei", name: "Ronin" },
  "0x46f": { token: "LSK", gasUnit: "LSK units", name: "Lisk" },
  "0xaa36a7": { token: "ETH", gasUnit: "Gwei", name: "Sepolia" },
  "0x4268": { token: "ETH", gasUnit: "Gwei", name: "Holesky" },
  "0x13882": { token: "MATIC", gasUnit: "Gwei", name: "Polygon Amoy" },
  "0x61": { token: "tBNB", gasUnit: "Gwei", name: "BSC Testnet" },
  "0x66eee": { token: "ARB", gasUnit: "Gwei", name: "Arbitrum Sepolia" },
  "0x14a34": { token: "ETH", gasUnit: "Gwei", name: "Base Sepolia" },
  "0xaa37dc": { token: "ETH", gasUnit: "Gwei", name: "Optimism Sepolia" },
  "0xe705": { token: "ETH", gasUnit: "Gwei", name: "Linea Sepolia" },
  "0xfa2": { token: "FTM", gasUnit: "Gwei", name: "Fantom Testnet" },
  "0x27d8": { token: "xDAI", gasUnit: "Gwei", name: "Gnosis Chiado" },
  "0x15b32": { token: "CHZ", gasUnit: "Gwei", name: "Chiliz Testnet" },
  "0x507": { token: "DEV", gasUnit: "Gwei", name: "Moonbase" },
  "0xa0c71fd": { token: "ETH", gasUnit: "Gwei", name: "Blast Sepolia" },
  "0x12c": { token: "ETH", gasUnit: "Gwei", name: "zkSync Sepolia" },
  "0x138b": { token: "MNT", gasUnit: "Gwei", name: "Mantle Sepolia" },
  "0x98a": { token: "MATIC", gasUnit: "Gwei", name: "Polygon zkEVM Cardona" },
  "0x1b59": { token: "ZETA", gasUnit: "Gwei", name: "Zetachain Testnet" },
  "0x221": { token: "FLOW", gasUnit: "FLOW units", name: "Flow Testnet" },
  "0x7e5": { token: "RON", gasUnit: "Gwei", name: "Ronin Saigon Testnet" },
  "0x106a": { token: "LSK", gasUnit: "LSK units", name: "Lisk Sepolia" },
  "0x0": { token: "BTC", gasUnit: "Sats/byte", name: "Bitcoin" },
  "0x1399c": { token: "SOL", gasUnit: "Lamports", name: "Solana" },
  "0x162": { token: "DOT", gasUnit: "Plancks", name: "Polkadot" },
  "0x2611": { token: "XPL", gasUnit: "Gwei", name: "Plasma Mainnet" }
};
var EXPLORER_URLS = {
  eth: "https://etherscan.io",
  etc: "https://blockscout.com/etc/mainnet",
  polygon: "https://polygonscan.com",
  bsc: "https://bscscan.com",
  avalanche: "https://snowtrace.io",
  fantom: "https://ftmscan.com",
  arbitrum: "https://arbiscan.io",
  optimism: "https://optimistic.etherscan.io",
  zkSync: "https://explorer.zksync.io",
  base: "https://basescan.org",
  linea: "https://lineascan.build",
  scroll: "https://scrollscan.com",
  mantle: "https://explorer.mantle.xyz",
  goerli: "https://goerli.etherscan.io",
  sepolia: "https://sepolia.etherscan.io",
  mumbai: "https://mumbai.polygonscan.com",
  plasma: "https://plasmascan.to"
};
var PROTOCOL_EXPLORERS = {
  chainlink_ccip: {
    name: "CCIP Explorer",
    templates: {
      // e.g. https://ccip.chain.link/msg/0x4ffce348…15a9519
      message: "https://ccip.chain.link/msg/{id}"
    }
  },
  wormhole: {
    name: "WormholeScan",
    templates: {
      // e.g. https://wormholescan.io/#/tx/0xb4374b12…06f1642 — accepts a source
      // tx hash or a VAA id, so it backs both the `tx` and `message` resources.
      tx: "https://wormholescan.io/#/tx/{id}",
      message: "https://wormholescan.io/#/tx/{id}"
    }
  }
};
var TESTNET_TO_MAINNET = {
  goerli: "eth",
  sepolia: "eth",
  mumbai: "polygon",
  bsc_testnet: "bsc",
  gnosis_chiado: "gnosis",
  chiliz_spicy: "chiliz",
  base_goerli: "base",
  optimism_goerli: "optimism",
  klaytn_baobab: "klaytn",
  celo_alfajores: "celo",
  kava_testnet: "kava",
  metis_goerli: "metis",
  harmony_testnet: "harmony",
  zkSync_testnet: "zkSync",
  aurora_testnet: "aurora",
  moonbase: "moonbeam",
  zkSync_era_testnet: "zkSync_era",
  fuse_testnet: "fuse",
  linea_testnet: "linea",
  scroll_testnet: "scroll",
  mantle_testnet: "mantle"
};

// src/chains/registry.ts
function chainIsEvm(chain) {
  return chain.family === ChainFamily.EVM;
}
var ChainRegistry = class {
  bySlug = /* @__PURE__ */ new Map();
  byHex = /* @__PURE__ */ new Map();
  byCaip2 = /* @__PURE__ */ new Map();
  register(chain, { replace = false } = {}) {
    const existingSlug = this.bySlug.get(chain.slug);
    if (existingSlug && existingSlug !== chain && !replace) {
      throw new Error(
        `Chain slug "${chain.slug}" already registered; pass replace=true to overwrite.`
      );
    }
    if (chain.chainIdHex) {
      const existingHex = this.byHex.get(chain.chainIdHex);
      if (existingHex && existingHex.slug !== chain.slug && !replace) {
        throw new Error(
          `Chain hex ${chain.chainIdHex} already mapped to slug ${existingHex.slug}; pass replace=true to overwrite.`
        );
      }
    }
    this.bySlug.set(chain.slug, chain);
    if (chain.chainIdHex) this.byHex.set(chain.chainIdHex, chain);
    if (chain.caip2) this.byCaip2.set(chain.caip2, chain);
  }
  unregister(slug) {
    const chain = this.bySlug.get(slug);
    if (!chain) return null;
    this.bySlug.delete(slug);
    if (chain.chainIdHex) this.byHex.delete(chain.chainIdHex);
    if (chain.caip2) this.byCaip2.delete(chain.caip2);
    return chain;
  }
  clear() {
    this.bySlug.clear();
    this.byHex.clear();
    this.byCaip2.clear();
  }
  get(slug) {
    return this.bySlug.get(slug) ?? null;
  }
  /** Lookup by EVM hex chain id (auto `0x`-prefixes + lowercases). */
  getByHex(chainIdHex) {
    let normalized = chainIdHex.toLowerCase();
    if (!normalized.startsWith("0x")) normalized = "0x" + normalized.replace(/^0x/, "");
    return this.byHex.get(normalized) ?? null;
  }
  /** Lookup by CAIP-2 chain id (e.g. "eip155:1"). */
  getByCaip2(caip2) {
    return this.byCaip2.get(caip2.trim().toLowerCase()) ?? null;
  }
  /** Resolve by CAIP-2, hex, OR slug. */
  resolve(value) {
    if (!value) return null;
    if (value.includes(":")) {
      const hit = this.getByCaip2(value);
      if (hit) return hit;
    }
    if (value.startsWith("0x")) {
      const hit = this.getByHex(value);
      if (hit) return hit;
    }
    if (/^\d+$/.test(value)) {
      const hit = this.getByHex("0x" + BigInt(value).toString(16));
      if (hit) return hit;
    }
    return this.get(value.toLowerCase());
  }
  byFamily(family) {
    return [...this.bySlug.values()].filter((c) => c.family === family).sort((a, b) => a.slug.localeCompare(b.slug));
  }
  all() {
    return [...this.bySlug.values()].sort((a, b) => a.slug.localeCompare(b.slug));
  }
};
var registry = new ChainRegistry();
function registerChain(chain, opts) {
  registry.register(chain, opts);
}
function resolveChain(value) {
  return registry.resolve(value);
}
function toHexChainId(value) {
  if (!value) return null;
  return registry.resolve(value)?.chainIdHex ?? null;
}
function toStoredChainId(value) {
  if (!value) return null;
  const chain = registry.resolve(value);
  if (!chain) return value;
  return chain.chainIdHex ?? chain.slug;
}
function toChainSlug(value) {
  if (!value) return null;
  return registry.resolve(value)?.slug ?? value;
}
function allChainIdHex() {
  return registry.all().map((c) => c.chainIdHex).filter((x) => x !== null).sort();
}
function evmCompatibleChains() {
  return new Set(registry.all().filter((c) => c.family === ChainFamily.EVM).map((c) => c.slug));
}
function getChainMetadata(chainId) {
  return registry.resolve(chainId);
}
function isEVM(chainId) {
  return registry.resolve(chainId)?.family === ChainFamily.EVM;
}
var DEFAULT_EXPLORER_PATHS = {
  tx: "tx",
  address: "address",
  block: "block",
  token: "token"
};
var explorerOverrides = /* @__PURE__ */ new Map();
var explorerPathDefaults = {};
function explorerKey(chainId) {
  if (chainId == null) return null;
  return registry.resolve(chainId)?.slug ?? (String(chainId).trim().toLowerCase() || null);
}
function configureExplorers(config) {
  if (config.paths) explorerPathDefaults = { ...explorerPathDefaults, ...config.paths };
  if (config.chains) {
    for (const [id, cfg] of Object.entries(config.chains)) {
      const key = explorerKey(id);
      if (!key) continue;
      const prev = explorerOverrides.get(key);
      explorerOverrides.set(key, {
        ...prev,
        ...cfg,
        paths: { ...prev?.paths, ...cfg.paths }
      });
    }
  }
}
function clearExplorerConfig() {
  explorerOverrides.clear();
  explorerPathDefaults = {};
}
function getExplorerConfig(chainId) {
  const chain = registry.resolve(chainId);
  const key = explorerKey(chainId);
  const override = key ? explorerOverrides.get(key) : void 0;
  const raw = override?.baseUrl ?? chain?.explorerUrl;
  if (!raw) return null;
  return { name: override?.name ?? null, baseUrl: raw.replace(/\/+$/, "") };
}
function getExplorerUrl(value, chainId, type = "tx") {
  const config = getExplorerConfig(chainId);
  if (!config) return null;
  const key = explorerKey(chainId);
  const override = key ? explorerOverrides.get(key) : void 0;
  const path = override?.paths?.[type] ?? explorerPathDefaults[type] ?? DEFAULT_EXPLORER_PATHS[type];
  return `${config.baseUrl}/${path}/${value}`;
}
function getProtocolExplorerUrl(protocolId, value, resource = "message") {
  if (!protocolId || !value) return null;
  const template = PROTOCOL_EXPLORERS[protocolId]?.templates[resource];
  if (!template) return null;
  const id = value.split("/").map(encodeURIComponent).join("/");
  return template.replace("{id}", id);
}
function getProtocolExplorerName(protocolId) {
  if (!protocolId) return null;
  return PROTOCOL_EXPLORERS[protocolId]?.name ?? null;
}
function toCaip2(chainId) {
  return registry.resolve(chainId)?.caip2 ?? null;
}
function getChainBrandColor(chainId) {
  return registry.resolve(chainId)?.brandColor ?? null;
}
var NEUTRAL_CHAIN_COLOR = "#64748b";
function hexToRgba(hex, alpha) {
  const m = /^#?([0-9a-f]{6})$/i.exec(hex.trim());
  if (!m) return hex;
  const int = parseInt(m[1], 16);
  const r = int >> 16 & 255;
  const g = int >> 8 & 255;
  const b = int & 255;
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
function getChainGroupColors(chainId) {
  const chain = registry.resolve(chainId);
  const brandColor = chain?.brandColor ?? NEUTRAL_CHAIN_COLOR;
  return {
    slug: chain?.slug ?? null,
    name: chain?.name ?? (chainId ? String(chainId) : "Unknown chain"),
    brandColor,
    fill: hexToRgba(brandColor, 0.06),
    border: hexToRgba(brandColor, 0.45),
    text: brandColor
  };
}
function getChainLogo(chainId) {
  return registry.resolve(chainId)?.logoUrl ?? null;
}
function resolveChainByCaip2(caip2) {
  if (!caip2) return null;
  return registry.getByCaip2(caip2);
}
var REORG_DEPTHS_BY_SLUG = {
  eth: 12,
  polygon: 256,
  matic: 256,
  bsc: 15,
  arbitrum: 12,
  optimism: 12,
  base: 12,
  avalanche: 12,
  fantom: 12,
  cronos: 12,
  gnosis: 12,
  linea: 12,
  scroll: 12,
  mantle: 12,
  zksync: 12,
  zksync_era: 12,
  metis: 12,
  celo: 12,
  klaytn: 12,
  moonbeam: 12,
  moonriver: 12,
  harmony: 12,
  aurora: 12,
  fuse: 12,
  palm: 12,
  chiliz: 12,
  kava: 12,
  blast: 12,
  bitcoin: 6,
  solana: 32
};
var BLOCK_TIME_BY_SLUG = {
  eth: 12,
  etc: 13,
  polygon: 2,
  matic: 2,
  bsc: 3,
  arbitrum: 0.25,
  optimism: 2,
  base: 2,
  avalanche: 2,
  fantom: 1,
  cronos: 6,
  gnosis: 5,
  linea: 3,
  scroll: 3,
  mantle: 2,
  zksync: 1,
  zksync_era: 1,
  metis: 4,
  celo: 5,
  klaytn: 1,
  moonbeam: 12,
  moonriver: 12,
  harmony: 2,
  aurora: 1,
  fuse: 5,
  blast: 2,
  bitcoin: 600,
  solana: 0.4,
  polkadot: 6
};
var EXPLORER_SUPPLEMENT = {
  bitcoin: "https://blockstream.info",
  solana: "https://solscan.io",
  polkadot: "https://polkadot.subscan.io",
  cronos: "https://cronoscan.com",
  gnosis: "https://gnosisscan.io",
  celo: "https://celoscan.io",
  moonbeam: "https://moonscan.io",
  zkSync_era: "https://explorer.zksync.io",
  matic: "https://polygonscan.com"
};
function explorerFor(slug, rawSlug, mainnetSlug) {
  return EXPLORER_URLS[slug] ?? EXPLORER_URLS[rawSlug] ?? EXPLORER_SUPPLEMENT[slug] ?? EXPLORER_SUPPLEMENT[rawSlug] ?? (mainnetSlug ? EXPLORER_URLS[mainnetSlug] ?? EXPLORER_SUPPLEMENT[mainnetSlug] ?? null : null);
}
var BRAND_COLOR_BY_SLUG = {
  eth: "#627EEA",
  etc: "#328332",
  polygon: "#8247E5",
  matic: "#8247E5",
  bsc: "#F0B90B",
  arbitrum: "#28A0F0",
  optimism: "#FF0420",
  base: "#0052FF",
  avalanche: "#E84142",
  fantom: "#1969FF",
  cronos: "#002D74",
  gnosis: "#0B6E4F",
  linea: "#61DFFF",
  scroll: "#EBC28E",
  mantle: "#000000",
  zksync: "#8C8DFC",
  zksync_era: "#8C8DFC",
  metis: "#00DACC",
  celo: "#FCFF52",
  klaytn: "#FF1B1B",
  moonbeam: "#53CBC8",
  moonriver: "#C0C0C0",
  harmony: "#00AEE9",
  aurora: "#70D44B",
  fuse: "#B4F9BA",
  blast: "#FCFC03",
  kava: "#FF433E",
  bitcoin: "#F7931A",
  solana: "#14F195",
  polkadot: "#E6007A"
};
function brandColorFor(slug, mainnetSlug) {
  return BRAND_COLOR_BY_SLUG[slug] ?? (mainnetSlug ? BRAND_COLOR_BY_SLUG[mainnetSlug] ?? null : null);
}
var LOGO_URL_BY_SLUG = {};
var CAIP2_BY_SLUG = {
  bitcoin: "bip122:000000000019d6689c085ae165831e93",
  solana: "solana:5eykt4usfv8p8njdtrepy1vzqkqzkvdp",
  polkadot: "polkadot:91b171bb158e2d3848fa23a9f1c25182"
};
function deriveCaip2(slug, family, chainIdHex) {
  if (CAIP2_BY_SLUG[slug]) return CAIP2_BY_SLUG[slug];
  if (family === ChainFamily.EVM && chainIdHex) {
    return `eip155:${BigInt(chainIdHex).toString(10)}`;
  }
  return null;
}
var NON_EVM_OVERRIDES = {
  bitcoin: { family: ChainFamily.UTXO, decimals: 8, chainIdHex: null },
  solana: { family: ChainFamily.SOLANA, decimals: 9, chainIdHex: null },
  polkadot: { family: ChainFamily.OTHER, decimals: 10, chainIdHex: null }
};
function layerFor(slug) {
  if (LAYER1_CHAINS.includes(slug)) return "l1";
  if (LAYER2_CHAINS.includes(slug)) return "l2";
  if (SIDECHAINS.includes(slug)) return "sidechain";
  return "unknown";
}
function seedFromCanonical() {
  for (const [hexId, rawSlug] of Object.entries(CHAIN_MAPPING)) {
    const slug = rawSlug.toLowerCase();
    const config = CHAIN_CONFIG[hexId];
    const token = config?.token ?? "ETH";
    const override = NON_EVM_OVERRIDES[slug];
    const family = override?.family ?? ChainFamily.EVM;
    const decimals = override?.decimals ?? 18;
    const isTestnet = TESTNET_CHAINS.includes(rawSlug);
    let mainnetSlug = null;
    if (isTestnet) {
      const m = TESTNET_TO_MAINNET[rawSlug];
      if (m) mainnetSlug = m.toLowerCase();
    }
    const reorgDepth = REORG_DEPTHS_BY_SLUG[slug] ?? 12;
    const chainIdHex = hexId.toLowerCase();
    const metadata = { layer: layerFor(slug) };
    if (config?.gasUnit) metadata.gasUnit = config.gasUnit;
    if (slug === "etc") {
      metadata.fork_of = "eth";
      metadata.note = "ETC shares pre-fork tx hashes with ETH. Audit sec. 2 calls out this collision risk.";
    }
    try {
      registry.register(
        {
          slug,
          chainIdHex,
          family,
          name: config?.name ?? rawSlug,
          nativeToken: token,
          decimals,
          isTestnet,
          mainnetSlug,
          reorgDepth,
          explorerUrl: explorerFor(slug, rawSlug, mainnetSlug),
          blockTimeSec: BLOCK_TIME_BY_SLUG[slug] ?? (mainnetSlug ? BLOCK_TIME_BY_SLUG[mainnetSlug] ?? null : null),
          caip2: deriveCaip2(slug, family, chainIdHex),
          brandColor: brandColorFor(slug, mainnetSlug),
          logoUrl: LOGO_URL_BY_SLUG[slug] ?? (mainnetSlug ? LOGO_URL_BY_SLUG[mainnetSlug] ?? null : null),
          metadata
        },
        { replace: true }
      );
    } catch {
      continue;
    }
  }
  for (const [slug, ovr] of Object.entries(NON_EVM_OVERRIDES)) {
    if (registry.get(slug)) continue;
    const nativeToken = slug === "bitcoin" ? "BTC" : slug === "solana" ? "SOL" : slug === "polkadot" ? "DOT" : "?";
    try {
      registry.register(
        {
          slug,
          chainIdHex: ovr.chainIdHex,
          family: ovr.family,
          name: slug[0].toUpperCase() + slug.slice(1),
          nativeToken,
          decimals: ovr.decimals,
          isTestnet: false,
          mainnetSlug: null,
          reorgDepth: REORG_DEPTHS_BY_SLUG[slug] ?? 12,
          explorerUrl: explorerFor(slug, slug, null),
          blockTimeSec: BLOCK_TIME_BY_SLUG[slug] ?? null,
          caip2: deriveCaip2(slug, ovr.family, ovr.chainIdHex),
          brandColor: brandColorFor(slug, null),
          logoUrl: LOGO_URL_BY_SLUG[slug] ?? null,
          metadata: {}
        },
        { replace: true }
      );
    } catch {
      continue;
    }
  }
}
seedFromCanonical();

// src/chains/options.ts
function valueFor(chain, kind) {
  switch (kind) {
    case "chainIdHex":
      return chain.chainIdHex;
    case "caip2":
      return chain.caip2;
    default:
      return chain.slug;
  }
}
function chainSelectOptions(config = {}) {
  const {
    valueKind = "slug",
    evmOnly = false,
    includeTestnets = false,
    sort = "name",
    fallback = "skip",
    chains
  } = config;
  const source = chains ?? registry.all();
  const out = [];
  for (const chain of source) {
    if (evmOnly && !chainIsEvm(chain)) continue;
    if (!includeTestnets && chain.isTestnet) continue;
    let value = valueFor(chain, valueKind);
    if (value == null) {
      if (fallback === "slug") value = chain.slug;
      else continue;
    }
    out.push({ value, label: chain.name, slug: chain.slug, isTestnet: chain.isTestnet });
  }
  out.sort(
    (a, b) => sort === "ethFirst" && (a.slug === "eth" || b.slug === "eth") ? a.slug === "eth" ? -1 : 1 : a.label.localeCompare(b.label)
  );
  return out;
}

// src/chains/finality.ts
var DEFAULT_REORG_DEPTH = 12;
var FAMILY_DEFAULT_DEPTHS = {
  [ChainFamily.EVM]: 12,
  [ChainFamily.UTXO]: 6,
  [ChainFamily.SOLANA]: 32,
  [ChainFamily.COSMOS]: 1,
  [ChainFamily.OTHER]: DEFAULT_REORG_DEPTH
};
function familyDefaultDepth(family) {
  return FAMILY_DEFAULT_DEPTHS[family] ?? DEFAULT_REORG_DEPTH;
}
function asChain(chainOrId) {
  return typeof chainOrId === "string" ? registry.resolve(chainOrId) : chainOrId;
}
function familyFor(chainOrId) {
  return asChain(chainOrId)?.family ?? null;
}
function finalityDepthFor(chainOrId) {
  const chain = asChain(chainOrId);
  if (!chain) return DEFAULT_REORG_DEPTH;
  return chain.reorgDepth ?? familyDefaultDepth(chain.family);
}
function finalityDepthForFamily(family) {
  return familyDefaultDepth(family);
}
function confirmedBlockForHead(head, chainOrId) {
  return Math.max(0, head - finalityDepthFor(chainOrId));
}
function isBlockFinalized(blockNumber, head, chainOrId) {
  return blockNumber <= confirmedBlockForHead(head, chainOrId);
}
var FinalityState = {
  UNKNOWN: "unknown",
  MEMPOOL: "mempool",
  PENDING: "pending",
  OBSERVED: "observed",
  CONFIRMED: "confirmed",
  FINALIZED: "finalized",
  REORGED: "reorged"
};

// src/chains/reorg.ts
function confirmationsFor(blockNumber, head) {
  return Math.max(0, head - blockNumber + 1);
}
function blocksUntilFinal(blockNumber, head, chainOrId) {
  const confirmed = confirmedBlockForHead(head, chainOrId);
  return Math.max(0, blockNumber - confirmed);
}
function computeFinalityState(input) {
  if (input.reorged) return FinalityState.REORGED;
  if (input.blockNumber == null) return FinalityState.PENDING;
  if (input.blockNumber <= confirmedBlockForHead(input.head, input.chainOrId)) {
    return FinalityState.FINALIZED;
  }
  if (input.head >= input.blockNumber) return FinalityState.CONFIRMED;
  return FinalityState.PENDING;
}
var ReorgTracker = class {
  seen = /* @__PURE__ */ new Map();
  chainMap(chainId) {
    let m = this.seen.get(chainId);
    if (!m) {
      m = /* @__PURE__ */ new Map();
      this.seen.set(chainId, m);
    }
    return m;
  }
  /** Observe a block; returns a `ReorgEvent` if its hash changed at that height. */
  observe(chainId, block) {
    const m = this.chainMap(chainId);
    const prev = m.get(block.number);
    m.set(block.number, block.hash);
    if (prev && prev !== block.hash) {
      return {
        chainId,
        height: block.number,
        previousHash: prev,
        newHash: block.hash,
        reorgDepthFrom: block.number
      };
    }
    return null;
  }
  /** True if `blockNumber` falls within the replay window of a reorg at `event`. */
  isInReplayWindow(event, blockNumber, chainOrId) {
    const depth = finalityDepthFor(chainOrId);
    return blockNumber >= event.reorgDepthFrom - depth;
  }
  reset(chainId) {
    if (chainId) this.seen.delete(chainId);
    else this.seen.clear();
  }
};

// src/chains/address.ts
var EVM_ZERO_ADDRESS = "0x0000000000000000000000000000000000000000";
var RE_EVM = /^0x[0-9a-fA-F]{40}$/;
var RE_BTC_BASE58 = /^(1|3)[1-9A-HJ-NP-Za-km-z]{25,39}$/;
var RE_BTC_BECH32 = /^(bc1|tb1)[0-9ac-hj-np-z]{11,71}$/;
var RE_SOLANA = /^[1-9A-HJ-NP-Za-km-z]{32,44}$/;
var RE_COSMOS_BECH32 = /^[a-z][a-z0-9]{1,10}1[0-9ac-hj-np-z]{38,58}$/;
function addressFamily(address, chainId) {
  if (chainId) {
    const fam = getChainMetadata(chainId)?.family;
    if (fam) return fam;
  }
  if (RE_EVM.test(address)) return ChainFamily.EVM;
  if (RE_BTC_BASE58.test(address) || RE_BTC_BECH32.test(address)) return ChainFamily.UTXO;
  if (RE_SOLANA.test(address)) return ChainFamily.SOLANA;
  if (RE_COSMOS_BECH32.test(address)) return ChainFamily.COSMOS;
  return null;
}
function normalizeAddress(address, chainId) {
  const addr = address.trim();
  const fam = addressFamily(addr, chainId);
  if (fam === ChainFamily.EVM) {
    const hex = addr.toLowerCase();
    return hex.startsWith("0x") ? hex : `0x${hex}`;
  }
  return addr;
}
function isValidAddress(address, chainId) {
  const addr = address.trim();
  if (!addr) return false;
  const fam = chainId ? getChainMetadata(chainId)?.family ?? null : addressFamily(addr);
  switch (fam) {
    case ChainFamily.EVM:
      return RE_EVM.test(addr);
    case ChainFamily.UTXO:
      return RE_BTC_BASE58.test(addr) || RE_BTC_BECH32.test(addr);
    case ChainFamily.SOLANA:
      return RE_SOLANA.test(addr);
    case ChainFamily.COSMOS:
      return RE_COSMOS_BECH32.test(addr);
    default:
      return RE_EVM.test(addr) || RE_BTC_BASE58.test(addr) || RE_BTC_BECH32.test(addr) || RE_SOLANA.test(addr) || RE_COSMOS_BECH32.test(addr);
  }
}
function isEvmAddress(address) {
  return RE_EVM.test(address.trim());
}
function isZeroAddress(address) {
  return normalizeAddress(address) === EVM_ZERO_ADDRESS;
}
function addressesEqual(a, b, chainId) {
  if (!a || !b) return false;
  return normalizeAddress(a, chainId) === normalizeAddress(b, chainId);
}
function shortenAddress(address, opts = {}) {
  const { lead = 6, trail = 4, ellipsis = "\u2026", keepPrefix = true } = opts;
  const addr = address.trim();
  const hasHexPrefix = keepPrefix && addr.startsWith("0x");
  const prefix = hasHexPrefix ? "0x" : "";
  const body = hasHexPrefix ? addr.slice(2) : addr;
  if (body.length <= lead + trail) return addr;
  return `${prefix}${body.slice(0, lead)}${ellipsis}${body.slice(-trail)}`;
}

// src/chains/tx.ts
var RE_HEX64 = /^(0x)?[0-9a-fA-F]{64}$/i;
var RE_SOLANA_SIG = /^[1-9A-HJ-NP-Za-km-z]{64,88}$/;
function normalizeTxHash(txHash, chainId) {
  const h = txHash.trim();
  const fam = chainId ? getChainMetadata(chainId)?.family ?? null : null;
  if (fam === ChainFamily.SOLANA || !RE_HEX64.test(h) && RE_SOLANA_SIG.test(h)) {
    return h;
  }
  if (RE_HEX64.test(h)) {
    const bare = h.replace(/^0x/i, "").toLowerCase();
    if (fam === ChainFamily.UTXO) return bare;
    return `0x${bare}`;
  }
  return h;
}
function isValidTxHash(txHash, chainId) {
  const h = txHash.trim();
  if (!h) return false;
  const fam = chainId ? getChainMetadata(chainId)?.family ?? null : null;
  if (fam === ChainFamily.SOLANA) return RE_SOLANA_SIG.test(h);
  if (fam === ChainFamily.EVM || fam === ChainFamily.UTXO) return RE_HEX64.test(h);
  return RE_HEX64.test(h) || RE_SOLANA_SIG.test(h);
}
function crossChainGroupingKey(input) {
  const chain = getChainMetadata(input.chainId);
  const chainKey = chain?.slug ?? (input.chainId ?? "unknown").toString().toLowerCase();
  return `${chainKey}:${normalizeTxHash(input.txHash, input.chainId)}`;
}
function groupByTx(records, accessor) {
  const groups = /* @__PURE__ */ new Map();
  for (const record of records) {
    const key = crossChainGroupingKey(accessor(record));
    const bucket = groups.get(key);
    if (bucket) bucket.push(record);
    else groups.set(key, [record]);
  }
  return groups;
}

export { CHAIN_CONFIG, CHAIN_MAPPING, ChainFamily, DEFAULT_REORG_DEPTH, EVM_ZERO_ADDRESS, EXPLORER_URLS, FinalityState, LAYER1_CHAINS, LAYER2_CHAINS, MAINNET_CHAINS, PROTOCOL_EXPLORERS, ReorgTracker, SIDECHAINS, TESTNET_CHAINS, TESTNET_TO_MAINNET, addressFamily, addressesEqual, allChainIdHex, blocksUntilFinal, chainIsEvm, chainSelectOptions, clearExplorerConfig, computeFinalityState, configureExplorers, confirmationsFor, confirmedBlockForHead, crossChainGroupingKey, evmCompatibleChains, familyDefaultDepth, familyFor, finalityDepthFor, finalityDepthForFamily, getChainBrandColor, getChainGroupColors, getChainLogo, getChainMetadata, getExplorerConfig, getExplorerUrl, getProtocolExplorerName, getProtocolExplorerUrl, groupByTx, isBlockFinalized, isChainFamily, isEVM, isEvmAddress, isValidAddress, isValidTxHash, isZeroAddress, normalizeAddress, normalizeTxHash, registerChain, registry, resolveChain, resolveChainByCaip2, shortenAddress, toCaip2, toChainSlug, toHexChainId, toStoredChainId };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map